export type RuntimePlatform = 'ios' | 'android' | 'web'
export const isServer = typeof window === 'undefined'

type CapGlobal = { getPlatform?: () => string; isNativePlatform?: () => boolean }
declare global { interface Window { Capacitor?: CapGlobal } }

const cap = (): CapGlobal | undefined => (isServer ? undefined : window.Capacitor)

export const getPlatform = (): RuntimePlatform => {
    const p = cap()?.getPlatform?.()
    return p === 'ios' || p === 'android' ? p : 'web'
}

export const isApp = (): boolean => !isServer && !!cap()?.isNativePlatform?.()
